/* Where We Deliver - postcode checker + FAQ accordion.
   No dependencies. Progressive enhancement: the page reads fully without it. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Postcode checker
     ------------------------------------------------------------------ */
  function initChecker(root) {
    if (root.getAttribute('data-wwd-ready') === '1') return;
    root.setAttribute('data-wwd-ready', '1');

    var input = root.querySelector('[data-wwd-input]');
    var submit = root.querySelector('[data-wwd-submit]');
    var hint = root.querySelector('[data-wwd-hint]');
    var live = root.querySelector('[data-wwd-results]');
    var panels = {};
    var dataUrl = root.getAttribute('data-coverage-url');
    var fallbackUrl = root.getAttribute('data-fallback-url') || '/collections/all';
    var coverage = null;
    var loading = null;
    var pending = null;

    if (!input || !submit || !live) return;

    Array.prototype.forEach.call(live.querySelectorAll('[data-wwd-result]'), function (p) {
      panels[p.getAttribute('data-wwd-result')] = p;
    });

    function loadCoverage() {
      if (coverage) return Promise.resolve(coverage);
      if (loading) return loading;
      loading = fetch(dataUrl, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('coverage ' + r.status); return r.json(); })
        .then(function (json) { coverage = json; return coverage; })
        .catch(function (err) { loading = null; throw err; });
      return loading;
    }

    function inRange(list, n) {
      if (!list) return null;
      for (var i = 0; i < list.length; i++) {
        if (n >= list[i].lo && n <= list[i].hi) return list[i];
      }
      return null;
    }

    /* Postcodes the merchant has paused in Theme settings, shared with the cart
       picker and checkout via snippets/blocked-postcodes.liquid. */
    function isBlocked(pc) {
      var shared = window.FCBlockedPostcodes;
      return !!(shared && shared.isBlocked(pc));
    }

    /* Evaluation order per handoff: Klang Valley -> excluded -> partner -> check */
    function lookup(pc) {
      var n = parseInt(pc, 10);
      var hit = inRange(coverage.klangValley, n);
      if (hit) return { kind: 'kv', postcode: pc, city: hit.city, price: hit.price || '', url: '' };
      hit = inRange(coverage.excluded, n);
      if (hit) return { kind: 'none', postcode: pc, city: hit.city || '', price: '', url: '' };
      hit = inRange(coverage.partners, n);
      if (hit) return { kind: 'covered', postcode: pc, city: hit.city, price: hit.price || '', url: hit.url || '' };
      return { kind: 'check', postcode: pc, city: '', price: '', url: '' };
    }

    function hideAll() {
      Object.keys(panels).forEach(function (k) { panels[k].hidden = true; });
    }

    function render(result) {
      hideAll();
      /* Older section markup has no 'blocked' panel - fall back to 'not covered'
         rather than answering with a blank result. */
      var panel = panels[result.kind] || panels.none;
      if (!panel) return;
      Array.prototype.forEach.call(panel.querySelectorAll('[data-wwd-var]'), function (el) {
        el.textContent = result[el.getAttribute('data-wwd-var')] || '';
      });
      var shop = panel.querySelector('[data-wwd-shop-link]');
      if (shop) shop.setAttribute('href', result.url || shop.getAttribute('data-wwd-shop-link') || fallbackUrl);
      panel.hidden = false;
    }

    function showHint(text) {
      if (!hint) return;
      if (text) hint.textContent = text;
      hint.hidden = false;
    }
    function clearHint() {
      if (!hint) return;
      hint.hidden = true;
      hint.textContent = hint.getAttribute('data-wwd-hint');
    }

    function setUrlPostcode(pc) {
      if (!(window.history && window.history.replaceState)) return;
      try {
        var u = new URL(window.location.href);
        if (pc) { u.searchParams.set('postcode', pc); } else { u.searchParams.delete('postcode'); }
        window.history.replaceState(null, '', u.toString());
      } catch (e) { /* ignore */ }
    }

    function resolve(pc, updateUrl) {
      pending = pc;
      /* A paused postcode outranks every coverage rule, Klang Valley included,
         and needs no coverage data - so answer before the fetch. */
      if (isBlocked(pc)) {
        render({ kind: 'blocked', postcode: pc, city: '', price: '', url: '' });
        if (updateUrl) setUrlPostcode(pc);
        return;
      }
      loadCoverage().then(function () {
        if (pending !== pc) return;
        render(lookup(pc));
        if (updateUrl) setUrlPostcode(pc);
      }).catch(function () {
        if (pending !== pc) return;
        hideAll();
        showHint(hint ? hint.getAttribute('data-wwd-error') : '');
      });
    }

    function sanitise(v) {
      return (v || '').replace(/\D/g, '').slice(0, 5);
    }

    function onInput() {
      var v = sanitise(input.value);
      if (input.value !== v) input.value = v;
      clearHint();
      if (v.length === 5) {
        resolve(v, false);
      } else {
        pending = null;
        hideAll();
      }
    }

    function check() {
      var v = sanitise(input.value);
      if (v.length !== 5) {
        pending = null;
        hideAll();
        showHint();
        return;
      }
      clearHint();
      resolve(v, true);
    }

    function reset() {
      pending = null;
      input.value = '';
      clearHint();
      hideAll();
      setUrlPostcode('');
      input.focus();
    }

    input.addEventListener('input', onInput);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); check(); }
    });
    submit.addEventListener('click', function (e) { e.preventDefault(); check(); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-wwd-reset]'), function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); reset(); });
    });

    /* Deep link: ?postcode=NNNNN */
    var qp = '';
    try { qp = new URLSearchParams(window.location.search).get('postcode') || ''; } catch (e) { /* ignore */ }
    if (/^\d{5}$/.test(qp)) {
      input.value = qp;
      resolve(qp, false);
    } else {
      /* Warm the cache so the first full postcode resolves instantly */
      input.addEventListener('focus', function () { loadCoverage().catch(function () {}); }, { once: true });
    }
  }

  /* ------------------------------------------------------------------
     FAQ accordion - one open at a time; first item open on load (markup)
     ------------------------------------------------------------------ */
  function initFaq(root) {
    if (root.getAttribute('data-wwd-ready') === '1') return;
    root.setAttribute('data-wwd-ready', '1');

    var triggers = root.querySelectorAll('[data-wwd-faq-trigger]');
    if (!triggers.length) return;

    function setOpen(trigger, open) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
    }

    Array.prototype.forEach.call(triggers, function (t) {
      t.addEventListener('click', function () {
        var isOpen = t.getAttribute('aria-expanded') === 'true';
        Array.prototype.forEach.call(triggers, function (other) {
          if (other !== t) setOpen(other, false);
        });
        setOpen(t, !isOpen);
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-wwd-checker]'), initChecker);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-wwd-faq]'), initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Theme editor: sections are re-rendered on setting changes */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
